export default {
      id: "i-logo-usage",
      viewBox: "0 0 20642 5762",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo",
      toString: function () {
        return this.url;
      }
    }